/* eslint-disable no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Separator, ErrorBoundary, ChooseCreativeModal } from 'components';
import { applicationActions } from 'store/actions';
import ConversionTrackingSection from '../../conversionTrackingSection/ConversionTrackingSection';
import { TopContainer, NativeTab, BannersTab } from './components';
import { useLockBodyScroll } from 'utils';

export const SelectedCreative = ({ selectedCreativeItem$, environment, changeTabActionRef }) => {
  const dispatch = useDispatch();

  const [tab, setTab] = useState('native');

  useEffect(() => {
    changeTabActionRef.current = { changeTabToDefaultAction: () => setTab('native') };
  }, []);

  const showNewCreativeModal = useSelector((state) => state.application.showNewCreativeModal);
  const creativeModalType = useSelector((state) => state.application.creativeModalType);

  const handleNewCreativeClose = () => {
    dispatch(applicationActions.closeNewCreativeModal());
  };

  useLockBodyScroll(showNewCreativeModal);

  const isNewCreative = useMemo(() => {
    if (typeof selectedCreativeItem$.value.bn_bannerid === 'number') return false;
    return true;
  }, [selectedCreativeItem$.value.bn_bannerid]);

  return (
    <div>
      <TopContainer isNewCreative={isNewCreative} tab={tab} setTab={setTab} />
      {tab === 'native' && <NativeTab isNewCreative={isNewCreative} />}
      {tab === 'banners' && <BannersTab isNewCreative={isNewCreative} />}
      <Separator marginTop={32} />
      {(selectedCreativeItem$.value?.status === 1 || selectedCreativeItem$.value?.status === 0) && (
        <>
          <ChooseCreativeModal
            open={showNewCreativeModal}
            creativeModalType={creativeModalType}
            handleClose={handleNewCreativeClose}
          />
          <ErrorBoundary>
            <ConversionTrackingSection environment={environment} />
          </ErrorBoundary>
          <Separator />
        </>
      )}
    </div>
  );
};
